import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedComponent } from './shared.component';
import { PriceSummaryComponent } from './price-summary/price-summary.component';
import { IonicModule } from '@ionic/angular';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GeneralNotificationComponent } from './general-notification/general-notification.component';
import { CheckoutStatusComponent } from './checkout-status/checkout-status.component';
import { MapLocatorComponent } from './map-locator/map-locator.component';
import { GoogleMapsModule } from '@angular/google-maps';
import { ShippingAddressFormComponent } from './shipping-address-form/shipping-address-form.component';
import { DeleteShippingAddressComponent } from './delete-shipping-address/delete-shipping-address.component';
import { ContactInfoFormComponent } from './contact-info-form/contact-info-form.component';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { GooglePlaceModule } from "ngx-google-places-autocomplete";
import { AgmCoreModule } from '@agm/core';
import { TooltipsModule } from 'ionic4-tooltips';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { SmilePointsComponent } from './smile-points/smile-points.component';
import { environment } from 'src/environments/environment';
import { ViewCmsContentComponent } from './view-cms-content/view-cms-content.component';
import { SuccessComponent } from './success/success.component';
import { CfmModelComponent } from './cfm-view-form/cfm-model/cfm-model.component';
import { CfmViewFormComponent } from './cfm-view-form/cfm-view-form.component';
import { NgxSliderModule } from '@angular-slider/ngx-slider';
import { CreditLimitComponent } from './credit-limit/credit-limit.component';
import { PopoverComponent } from './popover/popover.component';
import { SessionTimeoutComponent } from './session-timeout/session-timeout.component';
import { NavBarComponent } from './nav-bar/nav-bar.component';
import { RelativeDatePipe } from '../pipes/relative-date.pipe';
import { SeperatePipe } from '../pipes/seperate.pipe';
import { DriverTimeoutComponent } from './driver-timeout/driver-timeout.component'; 
import { FooterComponent } from './footer/footer.component';
import { DepositAmountModalComponent } from './deposit-amount/deposit-amount-modal.component';
import { VerificationModalComponent } from './verification-modal/verification-modal.component';
import { NgOtpInputModule } from 'ng-otp-input';
import { ProRataPricesModalComponent } from './pro-rata-prices-modal/pro-rata-prices-modal.component';
import { AlternativeContactNumberComponent } from './alternative-contact-number/alternative-contact-number.component';
import { EsimModule } from '../esim/esim.module';
import { EtisalatConsentComponent } from './etisalat-consent/etisalat-consent.component';
import { BlanksimsuccessComponent } from './blanksimsuccess/blanksimsuccess.component';
import { LoaderComponent } from './loader/loader.component';
import { TradeInBannerComponent } from './trade-in-banner/trade-in-banner.component';
import { LayoutsModule } from "../layouts/layouts.module";
import { TabbyModalComponent } from './tabby-modal/tabby-modal.component';
import { OtpVerificationComponent } from './otp-verification/otp-verification.component';

import { PriceOrderReviewComponent } from './price-order-review/price-order-review.component';
@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    FormsModule,
    ReactiveFormsModule,
    GoogleMapsModule,
    NgOtpInputModule,
    GooglePlaceModule,
    NgIdleKeepaliveModule.forRoot(),
    TooltipsModule.forRoot(),
    NgxSliderModule,
    EsimModule,
    LayoutsModule,
    AgmCoreModule.forRoot({
      // apiKey: environment.MAP_KEY,
      libraries: ['places', 'visualization', 'drawing', 'geometry', 'places']
    }),
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    LayoutsModule
],
  declarations: [
    SharedComponent,
    PriceSummaryComponent,
    GeneralNotificationComponent,
    CheckoutStatusComponent,
    MapLocatorComponent,
    ShippingAddressFormComponent,
    DeleteShippingAddressComponent,
    ContactInfoFormComponent,
    SmilePointsComponent,
    ViewCmsContentComponent,
    SuccessComponent,
    CfmModelComponent,
    CfmViewFormComponent,
    CreditLimitComponent,
    PopoverComponent,
    SessionTimeoutComponent,
    NavBarComponent,
    DriverTimeoutComponent,
    FooterComponent,
    DepositAmountModalComponent,
    VerificationModalComponent,
    ProRataPricesModalComponent,
    AlternativeContactNumberComponent,
    EtisalatConsentComponent,
    BlanksimsuccessComponent,
    LoaderComponent,
    TradeInBannerComponent,
    TabbyModalComponent,
    OtpVerificationComponent,
    PriceOrderReviewComponent
  ],
  entryComponents: [
    PriceSummaryComponent,
    GeneralNotificationComponent,
    CheckoutStatusComponent,
    MapLocatorComponent,
    ShippingAddressFormComponent,
    DeleteShippingAddressComponent,
    ContactInfoFormComponent,
    SmilePointsComponent,
    ViewCmsContentComponent,
    SuccessComponent,
    CfmModelComponent,
    CfmViewFormComponent,
    CreditLimitComponent,
    PopoverComponent,
    SessionTimeoutComponent,
    NavBarComponent,
    DriverTimeoutComponent,
    FooterComponent,
    DepositAmountModalComponent,
    ProRataPricesModalComponent,
    AlternativeContactNumberComponent,
    EtisalatConsentComponent,
    BlanksimsuccessComponent,
    LoaderComponent,
    PriceOrderReviewComponent
  ],
  exports: [
    PriceSummaryComponent,
    GeneralNotificationComponent,
    CheckoutStatusComponent,
    MapLocatorComponent,
    ShippingAddressFormComponent,
    DeleteShippingAddressComponent,
    ContactInfoFormComponent,
    SmilePointsComponent,
    ViewCmsContentComponent,
    SuccessComponent,
    CfmModelComponent,
    CfmViewFormComponent,
    CreditLimitComponent,
    PopoverComponent,
    NavBarComponent,
    DriverTimeoutComponent,
    FooterComponent,
    DepositAmountModalComponent,
    ProRataPricesModalComponent,
    AlternativeContactNumberComponent,
    EtisalatConsentComponent,
    BlanksimsuccessComponent,
    LoaderComponent,
    PriceOrderReviewComponent
  ],
  
  providers:[
    SeperatePipe,
    RelativeDatePipe
  ]
})
export class SharedModule {}
export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http, environment.TRANSLATION_URL,'.json');
  // return new TranslateHttpLoader(http);
}
